import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BACKEND_URL, ENABLE_LOG } from '../config';

const SMTP_TIPO = 'CLIENTE';
const DEFAULT_SMS_BASE_URL = 'https://sistema.massivamovil.com/webservices';

const ConfigSMTP = ({ onVolver, showSmtp = true, showSms = true, title }) => {
  const [smtpConfig, setSmtpConfig] = useState({
    host: '',
    port: 587,
    secure: false, // Use TLS (true for SSL)
    useTls: true,
    user: '',
    pass: '',
    senderName: '',
    testEmail: '',
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [smsConfig, setSmsConfig] = useState({
    baseUrl: DEFAULT_SMS_BASE_URL,
    usuario: '',
    clave: '',
    activo: false,
  });
  const [smsStatus, setSmsStatus] = useState({ type: '', message: '' });

  useEffect(() => {
    const fetchConfig = async () => {
      if (!BACKEND_URL) {
        setStatus({ type: 'danger', message: 'BACKEND_URL no configurado.' });
        return;
      }
      const cleanUrl = BACKEND_URL.trim().replace(/\/$/, '');
      try {
        const response = await axios.get(`${cleanUrl}/api/config/smtp`, {
          params: { tipo: SMTP_TIPO },
        });
        if (response.data) {
          const data = response.data;
          setSmtpConfig(prev => ({
            ...prev,
            host: data.host || '',
            port: data.port || 587,
            secure: Boolean(data.secure),
            useTls: typeof data.useTls === 'boolean' ? data.useTls : true,
            user: data.user || '',
            senderName: data.senderName || '',
          }));
        }
      } catch (err) {
        if (ENABLE_LOG) console.error('SMTP config fetch error:', err.response?.data || err.message);
      }
      try {
        const responseSms = await axios.get(`${cleanUrl}/api/config/sms`);
        if (responseSms.data) {
          const dataSms = responseSms.data;
          setSmsConfig(prev => ({
            ...prev,
            baseUrl: dataSms.baseUrl || DEFAULT_SMS_BASE_URL,
            usuario: dataSms.usuario || '',
            activo: Boolean(dataSms.activo),
          }));
        }
      } catch (err) {
        if (ENABLE_LOG) console.error('SMS config fetch error:', err.response?.data || err.message);
      }
    };
    fetchConfig();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSmtpConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSecureChange = (e) => {
    const mode = e.target.value;
    setSmtpConfig(prev => ({
      ...prev,
      secure: mode === 'ssl',
      useTls: mode !== 'none',
      port: mode === 'ssl' ? 465 : mode === 'none' ? 25 : 587,
    }));
  };

  const handleSmsChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSmsConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!BACKEND_URL) {
      setStatus({ type: 'danger', message: 'BACKEND_URL no configurado.' });
      return;
    }
    const cleanUrl = BACKEND_URL.trim().replace(/\/$/, '');
    setStatus({ type: '', message: '' });
    try {
      await axios.post(`${cleanUrl}/api/config/smtp`, { ...smtpConfig, tipo: SMTP_TIPO });
      setStatus({ type: 'success', message: 'Configuracion SMTP guardada.' });
    } catch (err) {
      if (ENABLE_LOG) console.error('SMTP config save error:', err.response?.data || err.message);
      setStatus({ type: 'danger', message: err.response?.data?.error || 'No se pudo guardar la configuracion.' });
    }
  };

  const handleTestConnection = async () => {
    if (!BACKEND_URL) {
      setStatus({ type: 'danger', message: 'BACKEND_URL no configurado.' });
      return;
    }
    const cleanUrl = BACKEND_URL.trim().replace(/\/$/, '');
    setStatus({ type: '', message: '' });
    try {
      await axios.post(`${cleanUrl}/api/config/smtp/test`, { ...smtpConfig, tipo: SMTP_TIPO });
      setStatus({ type: 'success', message: 'Prueba SMTP exitosa.' });
    } catch (err) {
      if (ENABLE_LOG) console.error('SMTP test error:', err.response?.data || err.message);
      setStatus({ type: 'danger', message: err.response?.data?.error || 'Fallo la prueba SMTP.' });
    }
  };

  const handleSaveSms = async (e) => {
    e.preventDefault();
    if (!BACKEND_URL) {
      setSmsStatus({ type: 'danger', message: 'BACKEND_URL no configurado.' });
      return;
    }
    const cleanUrl = BACKEND_URL.trim().replace(/\/$/, '');
    setSmsStatus({ type: '', message: '' });
    try {
      await axios.post(`${cleanUrl}/api/config/sms`, smsConfig);
      setSmsStatus({ type: 'success', message: 'Configuracion SMS guardada.' });
    } catch (err) {
      if (ENABLE_LOG) console.error('SMS config save error:', err.response?.data || err.message);
      setSmsStatus({ type: 'danger', message: err.response?.data?.error || 'No se pudo guardar la configuracion SMS.' });
    }
  };

  return (
    <div className="container mt-4" style={{ minHeight: 'calc(100vh - 120px)' }}>
      <div className="card shadow-sm" style={{ maxWidth: '600px', margin: '0 auto', height: 'calc(100vh - 120px)' }}>
        <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">⚙️ {title || (showSmtp && showSms ? 'Configuración SMTP/SMS' : showSms ? 'Configuración SMS' : 'Configuración SMTP')}</h5>
          <button className="btn btn-sm btn-light text-secondary" onClick={onVolver}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        <div className="card-body" style={{ overflowY: 'auto' }}>
          {showSmtp && (
            <>
              <div className="alert alert-info small">
                <i className="bi bi-info-circle me-2"></i>
                Estos ajustes se usarán para comunicados masivos (SMTP tipo CLIENTE).
              </div>
              {status.message && (
                <div className={`alert alert-${status.type} small`}>
                  {status.message}
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Servidor SMTP (Host)</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    name="host"
                    value={smtpConfig.host}
                    onChange={handleChange}
                    placeholder="smtp.gmail.com" 
                    required
                  />
                </div>
                
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Puerto</label>
                    <input 
                      type="number" 
                      className="form-control" 
                      name="port"
                      value={smtpConfig.port}
                      onChange={handleChange}
                      placeholder="587" 
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Seguridad</label>
                    <select 
                      className="form-select" 
                      name="secureType"
                      value={smtpConfig.secure ? 'ssl' : smtpConfig.useTls ? 'tls' : 'none'}
                      onChange={handleSecureChange}
                    >
                      <option value="tls">STARTTLS (Puerto 587)</option>
                      <option value="ssl">SSL/TLS (Puerto 465)</option>
                      <option value="none">Ninguna (NO RECOMENDADO)</option>
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Usuario / Correo</label>
                  <input 
                    type="email" 
                    className="form-control" 
                    name="user"
                    value={smtpConfig.user}
                    onChange={handleChange}
                    placeholder="notificaciones@fiscalia.mil.ve" 
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Contraseña</label>
                  <input 
                    type="password" 
                    className="form-control" 
                    name="pass"
                    value={smtpConfig.pass}
                    onChange={handleChange}
                    placeholder="Dejar en blanco para mantener"
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label">Email de Prueba</label>
                  <input
                    type="email"
                    className="form-control"
                    name="testEmail"
                    value={smtpConfig.testEmail}
                    onChange={handleChange}
                    placeholder="pruebas@dominio.mil.ve"
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label">Nombre del Remitente</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    name="senderName"
                    value={smtpConfig.senderName}
                    onChange={handleChange}
                    placeholder="Fiscalía General Militar" 
                    required
                  />
                </div>

                <div className="d-grid gap-2">
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-save me-2"></i>Guardar Configuración
                  </button>
                  <button type="button" className="btn btn-outline-secondary" onClick={handleTestConnection}>
                    <i className="bi bi-envelope-check me-2"></i>Probar Conexión
                  </button>
                </div>
              </form>
            </>
          )}

          {showSms && (
            <>
              {showSmtp && <hr className="my-4" />}

              <div className="alert alert-info small">
                <i className="bi bi-info-circle me-2"></i>
                Configuracion SMS para envios masivos (MassivaMovil).
              </div>
              {smsStatus.message && (
                <div className={`alert alert-${smsStatus.type} small`}>
                  {smsStatus.message}
                </div>
              )}

              <form onSubmit={handleSaveSms}>
                <div className="mb-3">
                  <label className="form-label">Base URL</label>
                  <input
                    type="text"
                    className="form-control"
                    name="baseUrl"
                    value={smsConfig.baseUrl}
                    onChange={handleSmsChange}
                    placeholder={DEFAULT_SMS_BASE_URL}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Usuario</label>
                  <input
                    type="text"
                    className="form-control"
                    name="usuario"
                    value={smsConfig.usuario}
                    onChange={handleSmsChange}
                    placeholder="micorreo@midominio.com"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Clave</label>
                  <input
                    type="password"
                    className="form-control"
                    name="clave"
                    value={smsConfig.clave}
                    onChange={handleSmsChange}
                    placeholder="Dejar en blanco para mantener"
                  />
                </div>
                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="smsActivo"
                    name="activo"
                    checked={smsConfig.activo}
                    onChange={handleSmsChange}
                  />
                  <label className="form-check-label" htmlFor="smsActivo">Activo</label>
                </div>
                <div className="d-grid">
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-save me-2"></i>Guardar Configuracion SMS
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigSMTP;
